<template lang='pug'>
  .section-show(v-if='section')
    back-icon(v-if='isMobile')
    .section-title(v-text='section.name')
    .section-line
    articles(v-if='activeSection')
</template>

<script>
import Articles from './articles.vue'
import BackIcon from './back-icon.vue'
import { fullUrl } from '@/modules/services/utilities'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('faq')

export default {
  components: {
    Articles,
    BackIcon
  },

  computed: {
    ...mapGetters(['objectBySlug']),
    ...mapState(['sections', 'articles', 'activeSection']),

    isMobile: () => vueSupport.isMobile,

    section () {
      return this.objectBySlug('sections', this.sectionId)
    },

    sectionId () {
      if (!this.$route.params['sectionId']) {
        return 'top-questions'
      } else {
        return this.$route.params['sectionId']
      }
    }
  },

  watch: {
    sectionId (newVal) {
      if (newVal) {
        this.setArticlesPage(1)
        this.setSection()
      }
    }
  },

  mounted () {
    this.setSection()
  },

  methods: {
    ...mapMutations(['setActiveSection', 'setArticlesPage']),
    ...mapActions(['fetchArticles']),

    setSection () {
      this.setActiveSection(this.sectionId)
      this.fetchArticles()

      if (this.section) {
        this.$store.commit('setSeoMetaTitle', this.section.name)
        this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
        this.$store.commit('setSeoUpdate', true)
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .section-show {
    @include media-breakpoint-down(md) {
      margin-left: 5px;
      margin-right: 10px;
    }

    .section-title {
      @include font-weight-bold;
      font-size: 20px;
      text-transform: uppercase;
    }

    .section-line {
      height: 1px;
      margin-top: 8px;
      background-color: $black;
    }
  }
</style>
